module.exports = __webpack_public_path__ + "static/media/Sujal Gandhi.c10b6673.pdf";